// import React, { useEffect, useRef, useState } from "react";
// import styled from "styled-components";
// import axios from "../services/axios";
// import LoadingCard from "./LoadingCard";
// import XCard from "./XCard";
// import url from "../services/url";
// import { useParams } from "react-router-dom";
// import saveLog from "../services/saveLog";

// function NewDocumentForm({ candidate, reloadCandidate }) {
//   const [error, setError] = useState();
//   const [loading, setLoading] = useState(true);
//   const [documentForms, setDocumentForms] = useState([]);
//   const [expanded, setExpanded] = useState();
//   const documentFormRef = useRef();

//   // Effects and Events
//   useEffect(() => {
//     (async () => {
//       const { data } = await axios.get("/documents");
//       setDocumentForms(data);
//       setLoading(false);
//     })();
//   }, []);

//   function toggleExpanded() {
//     setExpanded(!expanded);
//   }

//   async function onClickSendDocumentForm() {
//     setError();
//     const id = documentFormRef.current.value;
//     try {
//       let alreadySent = false;
//       candidate.documentForms.forEach((form) => {
//         if (form.form != null && form.form._id === id) {
//           alreadySent = true;
//         }
//       });
//       if (alreadySent) {
//         setError("This form is already sent to the candidate.");
//         return;
//       }
//       const response = await axios.put("/candidates/" + candidate._id, {
//         documentForms: [
//           ...candidate.documentForms,
//           {
//             form: id,
//           },
//         ],
//       });
//       saveLog("JOINING_FORM_SENT", `Sent a joining form to ${candidate.name}`);
//       reloadCandidate();
//       setExpanded(false);
//     } catch (e) {
//       console.error(e);
//       setError("Something bad happened. Please try again.");
//     }
//   }

//   if (loading) return <LoadingCard />;
//   return (
//     <div className="card mb-3">
//       <div className="card-header flex">
//         Send Document Form
//         <button
//           className="btn btn-primary btn-sm ml-auto"
//           onClick={toggleExpanded}
//         >
//           <i
//             className={expanded ? "fa fa-minus-circle" : "fa fa-plus-circle"}
//           ></i>
//         </button>
//       </div>
//       {expanded ? (
//         <>
//           <div className="card-body">
//             <div className="form-group">
//               <label>Choose a Form Template</label>
//               {documentForms[0] ? (
//                 <select
//                   ref={documentFormRef}
//                   className="form-control"
//                   defaultValue={documentForms[0]._id}
//                 >
//                   {documentForms.map((documentForm, index) => (
//                     <option key={index} value={documentForm._id}>
//                       {documentForm.title}
//                     </option>
//                   ))}
//                 </select>
//               ) : null}
//             </div>
//             {error ? <div className="alert alert-danger">{error}</div> : null}
//             <div className="form-group">
//               <button
//                 className="btn btn-primary"
//                 onClick={onClickSendDocumentForm}
//               >
//                 Send
//               </button>
//             </div>
//           </div>
//         </>
//       ) : null}
//     </div>
//   );
// }

// const RequestedDocument = styled.li`
//   display: flex;
//   justify-content: space-between;

//   &:hover {
//     font-weight: bold;
//   }
// `;

// function DocumentForm({ form, reloadCandidate }) {
//   const [expanded, setExpanded] = useState(false);
//   const { id } = useParams();
//   const toggleExpanded = () => setExpanded(!expanded);
//   async function onClickInvalidate(event) {
//     try {
//       await axios.put("/candidates/" + id + "/invalidate-document-form", {
//         form: form._id,
//         invalid: [...form.invalid, event.target.getAttribute("document")],
//       });
//       reloadCandidate();
//     } catch (e) {
//       console.error(e);
//     }
//   }

//   if (form.form == null) return null;
//   return (
//     <div className="card mb-3">
//       <div className="card-header flex">
//         {form.form.title} {form.pending ? "(Pending)" : null}
//         <button
//           className="btn btn-primary btn-sm ml-auto"
//           onClick={toggleExpanded}
//         >
//           <i
//             className={expanded ? "fa fa-minus-circle" : "fa fa-plus-circle"}
//           ></i>
//         </button>
//       </div>
//       {expanded ? (
//         <div className="card-body">
//           <ol>
//             {form.pending &&
//               form.form.inputs.map((input) => (
//                 <RequestedDocument className="mb-3 row" key={input._id}>
//                   <div className="col-lg-6">{input.name}</div>
//                   <div className="col-lg-6">
//                     <div className="form-control"></div>
//                   </div>
//                 </RequestedDocument>
//               ))}
//             {form.inputs?.map((input) => (
//               <RequestedDocument className="mb-3 row" key={input._id}>
//                 <div className="col-lg-6">{input.name}</div>
//                 <div className="col-lg-6">
//                   <div className="form-control">{input.value}</div>
//                 </div>
//               </RequestedDocument>
//             ))}
//             {form.form.documents.map((requestedDocument, key) => {
//               return (
//                 <RequestedDocument className="mb-3" key={key}>
//                   {form.invalid.indexOf(requestedDocument._id) != -1 ? (
//                     <div className="text-danger">{requestedDocument.title}</div>
//                   ) : (
//                     requestedDocument.title
//                   )}
//                   {form.filled ? (
//                     <div>
//                       <a
//                         className="btn btn-sm btn-primary mr-1"
//                         target="_blank"
//                         href={url(
//                           "drive/" + form.submission[requestedDocument._id]
//                         )}
//                       >
//                         Open
//                       </a>
//                       <a
//                         className="btn btn-sm btn-primary mr-1"
//                         download
//                         href={url(
//                           "drive/" + form.submission[requestedDocument._id]
//                         )}
//                       >
//                         Download
//                       </a>
//                       <button
//                         document={requestedDocument._id}
//                         className="btn btn-sm btn-primary mr-1"
//                         onClick={onClickInvalidate}
//                       >
//                         Invalidate
//                       </button>
//                     </div>
//                   ) : null}
//                 </RequestedDocument>
//               );
//             })}
//           </ol>
//         </div>
//       ) : null}
//     </div>
//   );
// }

// function DocumentList({ candidate, reloadCandidate }) {
//   return (
//     <div>
//       {candidate.documentForms.map((form, key) => (
//         <DocumentForm form={form} key={key} reloadCandidate={reloadCandidate} />
//       ))}
//     </div>
//   );
// }

// function CandidateDocumentForms({ candidate, reloadCandidate }) {
//   return (
//     <XCard title="Document Forms">
//       <NewDocumentForm
//         candidate={candidate}
//         reloadCandidate={reloadCandidate}
//       />
//       <DocumentList candidate={candidate} reloadCandidate={reloadCandidate} />
//     </XCard>
//   );
// }

// export default CandidateDocumentForms;

import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "../services/axios";
import LoadingCard from "./LoadingCard";
import XCard from "./XCard";
import url from "../services/url";
import { useParams } from "react-router-dom";
import saveLog from "../services/saveLog";

function NewDocumentForm({ candidate, reloadCandidate }) {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [documentForms, setDocumentForms] = useState([]);
  const [application, setApplication] = useState();
  const [expanded, setExpanded] = useState();
  const [Checked, setChecked] = useState();
  const documentFormRef = useRef();
  let { id } = useParams();
  const textInput = useRef(null);

  useEffect(() => {
    axios
      .get("candidates/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((res) => {
        setApplication(res);
        setLoading(false);
      })
      .catch(console.error);
  }, []);

  // Effects and Events
  useEffect(() => {
    (async () => {
      const { data } = await axios.get("/documents", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setDocumentForms(data);
      setLoading(false);
      //console.log(application)
    })();
  }, []);

  function toggleExpanded() {
    setExpanded(!expanded);
  }
  

  useEffect(()=>{
    axios
    .get("candidateDocuments/formList/Skill", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
    .then((res) => {
   console.log("form list ",res.data);
    })
   
    .catch(console.error);
  })
console.log("adssssssssssssssssssssssssssssssssssssssssssssssssssssss");
  async function onClickSendDocumentForm() {
    setError();
    const id = documentFormRef.current.value;
    try {
      let alreadySent = false;
      candidate.documentForms.forEach((form) => {
        if (form.form != null && form.form._id === id) {
          alreadySent = true;
        }
      });
      if (alreadySent) {
        setError("This form is already sent to the candidate.");
        return;
      }
      const response = await axios.put(
        "/candidates/" + candidate._id,
        {
          documentForms: [
            ...candidate.documentForms,
            {
              form: id,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      saveLog("JOINING_FORM_SENT", `Sent a joining form to ${candidate.name}`);
      reloadCandidate();
      setExpanded(false);
    } catch (e) {
      console.error(e);
      setError("Something bad happened. Please try again.");
    }
  }

  if (loading) return <LoadingCard />;
  return (
    <div className="card mb-3">
      <div className="card-header flex">
        Send Document Form
        <button
          className="btn btn-primary btn-sm ml-auto"
          onClick={toggleExpanded}
        >
          <i
            className={expanded ? "fa fa-minus-circle" : "fa fa-plus-circle"}
          ></i>
        </button>
      </div>
      {expanded ? (
        <>
          <div className="card-body">
            <div className="form-group">
              <label>Choose a Form Template</label>
              {documentForms[0] ? (
                <select
                  ref={documentFormRef}
                  className="form-control"
                  defaultValue={documentForms[0]._id}
                >
                  {documentForms.map((documentForm, index) => (
                    <option key={index} value={documentForm._id}>
                      {documentForm.title}
                    </option>
                  ))}
                </select>
              ) : null}
            </div>
            {error ? <div className="alert alert-danger">{error}</div> : null}
            <div className="form-group">
              <button
                className="btn btn-primary"
                onClick={onClickSendDocumentForm}
              >
                Send
              </button>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

const RequestedDocument = styled.li`
  display: flex;
  justify-content: space-between;
  &:hover {
    font-weight: bold;
  }
`;

function DocumentForm({ form, reloadCandidate }) {
  const [expanded, setExpanded] = useState(false);
  const [message, setMessage] = useState();
  const { id } = useParams();
  const [editable, seteditable] = useState(false);
  const [filledForm, setfilledForm] = useState(form.pending);
  const [error, setError] = useState();
  const [submi, setsubmi] = useState();
  const textInput = useRef();
  const [NewFind, setNewFind] = useState();
  const [Token, setToken] = useState("");
  const [UploadCheck, setUploadCheck] = useState(false);
  const [CheckFilledForm, setCheckFilledForm] = useState(form.filled);

  const GetCandidateToken = async () => {
    //const response=await fetch(`http://172.17.103.25:4000/api/candidates/candidateToken/${id}`);
    const response = await fetch(url(`candidates/candidateToken/${id}`));
    const res = await response.json();
    setToken(res.token);
  };

  useEffect(() => {
    GetCandidateToken();
  }, []);
  useEffect(() => {
    setsubmi(form.submission);
    if (form.submission == null) {
      setUploadCheck(true);
    }
  }, [reloadCandidate]);

  const toggleExpanded = () => {
    setExpanded(!expanded);
    seteditable(false);
  };
  // useEffect(()=>{
  //     const fileInput = document.querySelector("#file_request_" + '123654');
  //     console.log(fileInput)
  // },[])

  async function onClickUpload(e) {
    setError();
    setMessage();
    setError();
    setMessage();
    let _error = "";
    {
      UploadCheck &&
        form.form.documents.map((doc) => {
          // File Input exists Test
          const fileInput = document.querySelector("#file_request_" + doc._id);
          //console.log(fileInput.files[0])
          if (fileInput.files[0] == undefined) {
            _error = "Please Upload All data.";
            return;
          }
          if (fileInput == null) {
            // This means that we cannot find the input field in the DOM
            _error = "Something is not working properly.";
            return;
          }
          // File exists Test
          const file = fileInput.files[0];
          if (doc.mandatory && file == null) {
            _error = "Please upload " + doc.title + " as it is mandatory.";
            return;
          }
          if (!file) return null;
          // Extension Test
          const extension = file?.name?.split(".").pop().trim().toLowerCase();
          if (
            doc.extensions
              .map((extension) => extension.trim())
              .indexOf(extension) == -1
          ) {
            _error =
              doc.title +
              " must be of the extension " +
              doc.extensions.join(", ") +
              ". You uploaded a " +
              extension +
              " file.";
            return;
          }
          // File Size Test
          const sizeLimit = doc.size;
          const fileSize = file.size / (1000 * 1000);
          if (fileSize > sizeLimit) {
            _error =
              doc.title +
              " is too large. Please upload a file less than " +
              doc.size +
              "mb";
            return;
          }
          return doc;
        });
    }
    // Check if any test failed
    if (_error != "") {
      setError(_error);
      return;
    }
    setMessage("Uploading the files. Please wait a moment.");
    var UploadImages = [];
    var uploadMap = {};
    let value = {};

    let uploadPromisesMap = form.form.documents.map((doc) => {
      setMessage("Uploading the " + doc.title + ". Please wait a moment.");
      const file = document.querySelector("#file_request_" + doc._id).files[0];
      console.log(file);
      if (file === undefined) {
        // console.log('undefined value is',doc._id);
        var UndefinedValue = doc._id;
        UploadImages.push(doc._id);
        setNewFind(UndefinedValue);
        value[UndefinedValue] = submi[UndefinedValue];
        //console.log('checing',submi)

        //console.log('shifting',submi[UndefinedValue])
      }
      const payload = new FormData();
      payload.append("file", file);
      return axios
        .post("/drive", payload, {
          headers: {
            Authorization: "Bearer " + Token,
          },
        })
        .then((res) => {
          uploadMap[doc._id] = res.data.uploadedFile._id;
          UploadImages.map((val) => {
           return uploadMap[val] = value[val];
          });
        });
    });
    Promise.all(uploadPromisesMap)
      .then(async () => {
        try {
          const inputs = form.form.inputs.map((input) => {
            const field = document.querySelector(`#input-${input._id}`);
            field.checkValidity();
            if (!field.validity) {
              throw new Error(
                `Field ${field.name} is invalid because ` +
                  field.validationMessage
              );
            }
            return { ...input, value: field.value };
          });

          const response = await axios.put(
            "/candidates/" + id + "/update-document-form",
            {
              form: form._id,
              uploadMap,
              inputs,
            },
            {
              headers: {
                Authorization: "Bearer " + Token,
              },
            }
          );
          reloadCandidate();
        } catch (e) {
          console.error(e);
          //setError(e.response.data.error.message);
        }
        setMessage("All files were uploaded.");
        //window.location.reload()
        reloadCandidate();
      })
      .catch((e) => {
        console.error(e);
        ///setError(e.response.data.error.message);
      });
    // Check if any file upload failed
    // if (_error != "") {
    //   setError(_error);
    //   return;
    // }
  }
  if (form.form == null) {
    return null;
  }
  //OnClick Update Form will visible

  const EditForm = () => {
    setExpanded(false);
    seteditable(!editable);
  };

  async function onClickInvalidate(event) {
    try {
      await axios.put(
        "/candidates/" + id + "/invalidate-document-form",
        {
          form: form._id,
          invalid: [...form.invalid, event.target.getAttribute("document")],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      reloadCandidate();
    } catch (e) {
      console.error(e);
    }
  }

  if (form.form == null) return null;
  return (
    <div className="card mb-3">
      <div className="card-header flex">
        {form.form.title} {form.pending ? "(Pending)" : null}
        <button
          className="btn btn-primary btn-sm ml-auto"
          onClick={toggleExpanded}
        >
          <i
            className={expanded ? "fa fa-minus-circle" : "fa fa-plus-circle"}
          ></i>
        </button>
        <button className="btn btn-outline-primary btn-sm " onClick={EditForm}>
          <i className="fa fa-edit"></i>
        </button>
      </div>

      {editable ? (
        <div className="card mb-3">
          {editable ? (
            <div className="card-body">
              <p>{form.form.description}</p>
              {CheckFilledForm
                ? form.inputs.map((input) => (
                    <div className="form-group" key={input._id}>
                      <label>
                        {input.name} {input.mandatory && "(*)"}
                      </label>
                      <input
                        id={"input-" + input._id}
                        className="form-control"
                        required={input.mandatory}
                        defaultValue={input.value}
                      />
                    </div>
                  ))
                : form.form.inputs.map((input) => (
                    <div className="form-group" key={input._id}>
                      <label>
                        {input.name} {input.mandatory && "(*)"}
                      </label>
                      <input
                        id={"input-" + input._id}
                        className="form-control"
                        required={input.mandatory}
                        defaultValue={input.value}
                      />
                    </div>
                  ))}
              {form.form.documents.map((doc, key) => (
                <div className="form-group" key={key}>
                  <label>
                    {doc.title}
                    {doc.mandatory && "(*)"}
                    {form.invalid.indexOf(doc._id) != -1 ? (
                      <small className="text-danger ml-2">
                        (The file you uploaded for {doc.title} was invalid.)
                      </small>
                    ) : null}
                  </label>
                  <input
                    id={"file_request_" + doc._id}
                    className="form-control"
                    type="file"
                  />
                  {/*<MutedHint>
                Allowed {doc.extensions.join(", ")} upto {doc.size}mb
              </MutedHint>*/}
                </div>
              ))}
              {error ? <div className="alert alert-danger">{error}</div> : null}
              {message ? (
                <div className="alert alert-success">{message}</div>
              ) : null}
              <div className="form-group">
                <button className="btn btn-primary" onClick={onClickUpload}>
                  Save
                </button>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {expanded ? (
        <div className="card-body">
          <ol>
            {form.pending
              ? form.inputs &&
                form.inputs.map((input) => (
                  <RequestedDocument className="mb-3 row" key={input._id}>
                    <div className="col-lg-6">{input.name}</div>
                    <div className="col-lg-6">
                      <div className="form-control">{input.value}</div>
                    </div>
                  </RequestedDocument>
                ))
              : form.inputs?.map((input) => (
                  <RequestedDocument className="mb-3 row" key={input._id}>
                    <div className="col-lg-6">{input.name}</div>
                    <div className="col-lg-6">
                      <div className="form-control">{input.value}</div>
                    </div>
                  </RequestedDocument>
                ))}
            {form.form.documents.map((requestedDocument, key) => {
              return (
                <RequestedDocument className="mb-3" key={key}>
                  {form.invalid.indexOf(requestedDocument._id) != -1 ? (
                    <div className="text-danger">{requestedDocument.title}</div>
                  ) : (
                    requestedDocument.title
                  )}
                  {form.filled ? (
                    <div>
                      <a
                        className="btn btn-sm btn-primary mr-1"
                        target="_blank"
                        href={url(
                          "drive/" + form.submission[requestedDocument._id]
                        )}
                      >
                        Open
                      </a>
                      <a
                        className="btn btn-sm btn-primary mr-1"
                        download
                        href={url(
                          "drive/" + form.submission[requestedDocument._id]
                        )}
                      >
                        Download
                      </a>
                      <button
                        document={requestedDocument._id}
                        className="btn btn-sm btn-primary mr-1"
                        onClick={onClickInvalidate}
                      >
                        Invalidate
                      </button>
                    </div>
                  ) : null}
                </RequestedDocument>
              );
            })}
          </ol>
        </div>
      ) : null}
    </div>
  );
}

function DocumentList({ candidate, reloadCandidate }) {
  return (
    <div>
      {candidate.documentForms.map((form, key) => (
        <DocumentForm form={form} key={key} reloadCandidate={reloadCandidate} />
      ))}
    </div>
  );
}

function CandidateDocumentForms({ candidate, reloadCandidate }) {
  const [interviewRound, setinterviewRound] = useState([]);
  let { id } = useParams();
  //console.log(id)
  const GetData = async () => {
    const response = await axios.put(
      url("interviews"),
      {
        candidate: id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    );
    const res = await response.data;
    // console.log(res)
    setinterviewRound(res);
  };
  useEffect(() => {
    GetData();
  }, []);
  return (
    <>
      {(interviewRound.length == 1 &&
        interviewRound[0].status == "Selected" &&
        interviewRound[0].type == "final") ||
      (interviewRound.length == 3 && interviewRound[2].type === "final" && interviewRound[2].status == "Selected" || 
      interviewRound.length == 3 && interviewRound[2].type === "clientRound" && interviewRound[2].status == "Selected"
      ) ||
      (interviewRound.length == 4 && interviewRound[3].type === "final" && interviewRound[3].status == "Selected" || 
      interviewRound.length == 4 && interviewRound[3].type === "clientRound" && interviewRound[3].status == "Selected"
      )
      ? (
        //this needs to be done
        <XCard title="Document Forms called" shadow="none">
          <NewDocumentForm
            candidate={candidate}
            reloadCandidate={reloadCandidate}
          />
          <DocumentList
            candidate={candidate}
            reloadCandidate={reloadCandidate}
          />
        </XCard>
      ) : null}
    </>
  );
}

export default CandidateDocumentForms;
